import z from "zod";
import type { Context } from "hono";

type Project = {
  id: string;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  thumbnailUrl: string | null;
};

export const getProjectsSearchParamsSchema = z.object({
  page: z.string().transform((val) => parseInt(val, 10)),
  search: z.string().optional(),
  sortBy: z.enum(["createdAt", "updatedAt"]).default("updatedAt"),
});

export type GetProjectsSearchParams = z.infer<
  typeof getProjectsSearchParamsSchema
>;

export type GetProjectsResponseBody = {
  total: number;
  projects: Project[];
};

export type GetProjectsHandlerReturnType = Promise<
  ReturnType<
    typeof Context.prototype.json<
      | GetProjectsResponseBody
      | { error: string }
      | { errors: z.ZodIssue[] }
      | string
    >
  >
>;
